import { motion } from "framer-motion"

import { IHowItWorksBullet } from "@/types"
import { childVariants } from "./HowItWorksSection"

const HowItWorksBullet: React.FC<IHowItWorksBullet> = ({ title, description, icon }: IHowItWorksBullet) => {
    return (
        <motion.div
            className="bg-white/30 backdrop-blur-lg border border-white/20 rounded-lg shadow-lg p-4 relative flex flex-col items-center mt-6 gap-3 lg:gap-5 lg:flex-row lg:items-start"
            variants={childVariants}
        >
            <div className="flex justify-center mx-auto lg:mx-0 flex-shrink-0 w-fit">
                {icon}
            </div>
            <div>
                <h4 className="text-lg font-semibold">
                    {title}
                </h4>
                <p className="text-base text-foreground-accent">
                    {description}
                </p>
            </div>
        </motion.div>
    )
}

export default HowItWorksBullet